<template>
    <div v-if="event.contact_name && event.contact_phone" class="dress_code_card">
        <div class="img_part">
            <img src="../assets/img/contact_person_icon.svg" alt="contact person icon">
        </div>
        <div class="content_part">
            <div class="title">
                {{$t(`ContactPersonWidget['Contact person']`)}}:
            </div>
            <div class="content">
                {{ event.contact_phone }} <b>({{ event.contact_name }})</b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['event'],
    name: "ContactPersonWidget"
}
</script>

<style scoped>

.dress_code_card {
    margin-bottom: 30px;
}
</style>
